export default "__VITE_ASSET__CEh9xFYS__"